
























































































import Vue, { PropType } from "vue";
import { PhoneNumber } from "./../../types/dossier/PhoneNumber";
import RequiredLabel from "./../interface/RequiredLabel.vue";
import { maxLength, required, requiredIf } from "vuelidate/lib/validators";
import DossierLabels from "./../mijnDossier/DossierLabels.js";
import DeleteButton from "./../interface/DeleteButton.vue";
import EraseButton from "./../interface/EraseButton.vue";
export default Vue.extend({
  name: "phone-input",
  components: { DeleteButton, RequiredLabel, EraseButton },
  props: {
    id: {
      type: String,
      required: true,
    },
    info: {
      type: String,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Object as PropType<PhoneNumber>,
    },
    selectValues: {
      type: Array,
    },
    isDirty: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      labels: DossierLabels,
    };
  },
  computed: {
    selectedNummer(): PhoneNumber {
      return this.value;
    },
    isRequired(): boolean {
      return Object.prototype.hasOwnProperty.call(this.$v, "required");
    },
    isNummerEmpty(): boolean {
      return this.selectedNummer.nummer == "";
    },
  },
  methods: {
    updateNummer(): void {
      this.$emit("input", this.selectedNummer);
    },
    updateNummerType(value: string) {
      this.selectedNummer.type = value;
      this.$emit("input", this.selectedNummer);
    },
    deletePhone(): void {
      this.$emit("delete-phone");
    },
    tooltipTextForNumber(): string {
      if (this.selectedNummer.id != 0) {
        return "Leegmaken";
      }
      return "Verwijderen";
    },
  },
  validations: {
    selectedNummer: {
      prefix: {
        maxLength: maxLength(5),
      },
      nummer: {
        maxLength: maxLength(20),
      },
      type: {
        required,
      },
      soort: {
      },
      opm: {
        requiredIf: requiredIf(
          (cnr) => {
            return cnr.nummer !== "" && cnr.type == "Noodnummer";
          }),
      },
    },
  },
  watch: {
    $v: {
      handler(value) {
        this.$emit("validation-change", value.$invalid);
      },
      deep: true,
    },
  },
});
